module.exports = __webpack_public_path__ + "media/images/mamari/wowma/require-brown-121043828f4da62a55f5cf9e5cf43e5a.png";